import { css } from '@emotion/css';

export const inputStyles = css`
  padding-inline-start: 1.2rem !important;
  padding-inline-end: 0.6rem !important;
`;
